/** The Tisunge mark: a green rounded square with a copper "T". Decorative; the name sits beside it. */
export function BrandMark({ size = 32 }: { size?: number }) {
  return (
    <svg className="brand-mark" width={size} height={size} viewBox="0 0 512 512" aria-hidden="true" focusable="false">
      <rect width="512" height="512" rx="112" fill="#1B6B3A" />
      <rect x="138" y="133" width="236" height="62" rx="16" fill="#F2A36B" />
      <rect x="223" y="133" width="66" height="256" rx="16" fill="#F2A36B" />
    </svg>
  )
}
